export const Color = {
  white: '#ffffff',
  veryDarkGrey: '#606060',
  mediumDarkGrey: '#6A6A6A',
  darkGrey: '#363636',
  grey: '#010101',
  silver: '#A1A1A1',
  darkSilver: '#858585',
  lightGrey: '#d3d3d3',
  lightGrey2: '#C7C7C7',
  mediumLightGrey: '#E8E8E8',
  veryLightGrey: '#D0D0D0',
  veryLightGrey2: '#F8F8F8',
  primary: process.env.GATSBY_MAIN_COLOR,
  secondary: process.env.GATSBY_SECOND_COLOR,
  tertiary: process.env.GATSBY_THIRD_COLOR,
  purple: '#a43d72',
  blue: '#3d72a4',
  black: '#000000',
  yellow: '#FEF8E1',
  transparent: 'transparent',
  red: '#C70303',
  lightRed: '#FEE1E1',
  gold: '#cea505',
};
